var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayTagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1195_8327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 0.150391L19.7871 10L10 19.7871L0.150391 9.9375V0.150391H9.9375ZM2.34961 8.8125L9.89355 16.3564L10 16.4619L10.1064 16.3564L16.3564 10.1064L16.4619 10L16.3564 9.89355L8.8125 2.34961H2.34961V8.8125ZM5.625 3.90039C6.57755 3.90039 7.34961 4.66573 7.34961 5.625C7.34961 6.57755 6.58427 7.34961 5.625 7.34961C4.67245 7.34961 3.90039 6.58427 3.90039 5.625C3.90039 4.67245 4.66573 3.90039 5.625 3.90039Z",
    fill: "currentFill",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1195_8327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTagIcon);
export default __webpack_public_path__ + "static/media/grayTagIcon.f25e2dfe9ba0d0c098d83a9fa6c50118.svg";
export { ForwardRef as ReactComponent };